export default {"src":"/evde-internet/_next/static/media/redCircleAlert.508904d6.svg","height":96,"width":96};